class PublicMethods {
  timestampToTime (timestamp) { // 时间戳转化------月-日
    var date = new Date(timestamp)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    // var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日'
    // var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';
    // var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) + ':';
    // var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
    return M + D
  };
  getWeeks (timestamp) { // 时间戳转化-----年.月.日 星期几
    var date = new Date(timestamp)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '.'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '.'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    var weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    var day = date.getDay()
    var week = weeks[day]
    return Y + M + D + '   ' + week
  };
  getTimestampToTime (timestamp) { // 时间戳转化------年-月-日 时：分
    var date = new Date(timestamp)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '      '
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
    // var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
    return Y + M + D + h + m
  };
  getTime (timestamp) { // 时间戳转化-----年-月-日
    var date = new Date(timestamp)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    // var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';
    // var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) + ':';
    // var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
    return Y + M + D
  };
  getMonth () { // 时间戳转化-------年-月
    var date = new Date()// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
    // var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    // var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';
    // var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) + ':';
    // var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
    return Y + M
  };
  getHours (timestamp) { // 时间戳转化-----时：分
    var date = new Date(timestamp)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '.'
    // var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '.'
    // var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
    // var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
    return h + m
  };
  // 通过code获取对应name
  getDisplayField (arr = [], code, state) {
    if (arr && arr.length <= 0) {
      return ''
    } else {
      let val = arr.find(item => item[code] == state)
      return val ? val['name'] : ''
    }
  };
}

var Methods = new PublicMethods()

export default Methods
